const imagePath = '/images/cases/design-991/decorations/'

export const config = {
  scopes: [
    'User research',
    'UI/uX',
    'Wireframing',
    'App mapping',
    'Visual Design',
  ],
  tools: ['Figma', 'After Effects', 'Illustrator'],
  titleScope: 'scope of work:',
  titleTools: 'tools:',
  imageDesktop: {
    src: `${imagePath}scope-desktop.webp`,
    alt: 'desktop scope image',
    fill: true,
  },
  imageMobile: {
    src: `${imagePath}scope-mobile.webp`,
    alt: 'mobile scope image',
    fill: true,
  },
}
